module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction"
    }
  }, [_vm._v("Tony Burke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbreviations"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01"
    }
  }, [_vm._v("I. GOSPELS AND RELATED TRADITIONS OF NEW TESTAMENT FIGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01"
    }
  }, [_vm._v("The Hospitality and Perfume of the Bandit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01"
    }
  }, [_vm._v("Mark Glen Bilby")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter02"
    }
  }, [_vm._v("The Gospel of the Twelve Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter02"
    }
  }, [_vm._v("James Toma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter03"
    }
  }, [_vm._v("The Dialogue between Jesus and the Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter03"
    }
  }, [_vm._v("Chance E. Bonar and Slavomír Čéplö")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of the Image of Edessa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nathan J. Hardy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dream of the Rood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexander D’Alisera and Samuel Osborn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eremitic Life of Mary Magdalene")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brandon W. Hawk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Martyrdom of Zechariah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tony Burke and Sarah Veale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Decapitation of John the Forerunner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tony Burke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. APOCRYPHAL ACTS AND RELATED TRADITIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of Andrew and Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian H. Bull and Alexander Kocar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of Andrew and Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ivan Miroshnikov")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of John Meeting Cerinthus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lorne R. Zelyck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of John in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Janet E. Spittler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of John by Prochorus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Janet E. Spittler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Memorial of John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rick Brannan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Martyrdom of Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tobias Nicklas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The History of Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jacob A. Lollar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Preaching of Simon Cephas in the City of Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Edward Walters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Disputation of Peter and Nero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Edward Walters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acts of Christ and Peter in Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Julia A. Snyder and Slavomír Čéplö")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Passion of Peter and Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carson Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Preaching of Philip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ivan Miroshnikov")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. EPISTLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Correspondence of Ignatius with John the Evangelist and the Virgin Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Gregory Given")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epistle of James to Quadratus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brent Landau, Bradley Rice, and J. Edward Walters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epistles of Longinus, Augustus, Ursinius, and Patrophilus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tony Burke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. APOCALYPSES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Revelation about the Lord’s Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Péter Tóth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dialogue of Mary and Christ on the Departure of the Soul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christine Luckritz Marquis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Questions of John (Interrogatio Iohannis)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen C. E. Hopkins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Revelation of Matthew about the End Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen Pelle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Revelation of Matthew about the End Times")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles D. Wright and Stephen Pelle")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dfd2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0